// extracted by mini-css-extract-plugin
export var avatarContainer = "_fc-0";
export var gray = "_fc-f";
export var green = "_fc-c";
export var icon = "_fc-9";
export var image = "_fc-1";
export var lg = "_fc-6";
export var md = "_fc-5";
export var presenceDot = "_fc-b";
export var red = "_fc-d";
export var sm = "_fc-4";
export var status = "_fc-a";
export var xl = "_fc-7";
export var xs = "_fc-3";
export var xxl = "_fc-8";
export var xxs = "_fc-2";
export var yellow = "_fc-e";